<script lang="ts">
	import { mergeAttributes } from '@vpap_svelte/internal';

	import type { SVGElementProps } from '@vpap_svelte/internal';

	let {
		children,
		width,
		height,
		viewBox,
		preserveAspectRatio,
		...attrs
	}: SVGElementProps<SVGSVGElement> = $props();

	let requiredProps: SVGElementProps<SVGSVGElement> = $derived.by(() => {
		if (
			viewBox === undefined &&
			preserveAspectRatio === undefined &&
			width !== null &&
			typeof width === 'number' &&
			height !== null &&
			typeof height === 'number'
		) {
			return {
				width,
				height,
				viewBox: `0 0 ${width} ${height}`,
				preserveAspectRatio: 'xMidYMid meet',
			};
		}
		return {
			width,
			height,
			viewBox,
			preserveAspectRatio,
		};
	});
	let svgAttrs = $derived(mergeAttributes(attrs, requiredProps));
</script>

<svg {...svgAttrs}>
	{#if children}
		{@render children()}
	{/if}
</svg>
